import news from '../content/news.json';

export function getHelsinkiDate(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Helsinki', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(now);
  const part = type => parts.find(value => value.type === type).value;
  return `${part('year')}-${part('month')}-${part('day')}`;
}

export function getPublishedNews(today = getHelsinkiDate(), entries = news) {
  return entries
    .filter(item => !item.draft && (!item.publishedAt || item.publishedAt <= today))
    .slice()
    .sort((a, b) => (b.publishedAt || '').localeCompare(a.publishedAt || ''));
}

export function getHomeNews(today = getHelsinkiDate(), entries = news) {
  return getPublishedNews(today, entries)
    .filter(item => item.publishedAt && item.homeUntil && today <= item.homeUntil)
    .slice(0, 2);
}

export function getActiveNotices(today = getHelsinkiDate(), entries = news) {
  return getPublishedNews(today, entries).filter(item => (
    item.notice && item.notice.from <= today && today <= item.notice.until
    && (!item.resolvedOn || today < item.resolvedOn)
  ));
}

export function formatNewsDate(date) {
  if (!date) return 'Päiväämätön arkistouutinen';
  const [year, month, day] = date.split('-');
  return `${Number(day)}.${Number(month)}.${year}`;
}
